import { motion } from 'framer-motion';
import { format, isFuture } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Box, Typography, Grid, Card, CardContent, CardMedia, Button, Tab, Tabs, Chip } from '@mui/material';

function List({ events, tabValue, setTabValue }) {
    const navigate = useNavigate();
    const handleTabChange = (event, newValue) => { setTabValue(newValue) };

    return (
        <Grid item xs={12} md={8}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab label="All Events" />
                    <Tab label="Upcoming" />
                    <Tab label="Past Events" />
                </Tabs>
            </Box>

            <Grid container spacing={3} sx={{ maxWidth: '700px', margin: '0 auto' }}>
                {events.map((event) => (
                    <Grid item xs={12} key={event.id}>
                        <motion.div variants={cardVariants}>
                            <Card
                                sx={{
                                    display: 'flex',
                                    width: '100%',
                                    maxWidth: '900px',
                                    margin: '0 auto',
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    position: 'relative',
                                    transition: 'all 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: '0 12px 40px rgba(0, 31, 63, 0.15)',
                                    },
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    sx={{
                                        width: { xs: '150px', sm: '250px', md: '300px' },
                                        height: '100%',
                                        objectFit: 'contain',
                                        transition: 'transform 0.3s ease-in-out',
                                        '&:hover': {
                                            transform: 'scale(1.05)',
                                        },
                                    }}
                                    image={event.imageUrl}
                                    alt={event.title}
                                />
                                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                    <CardContent sx={{ flex: '1 0 auto', p: 2, justifyContent: 'space-between', display: 'flex', flexDirection: 'column' }}>
                                        <Box >
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                                                <Typography variant="h5" sx={{
                                                    fontFamily: 'Bebas Neue',
                                                    fontSize: '1.8rem',
                                                    color: 'primary.main',

                                                }}>
                                                    {event.title}
                                                </Typography>
                                                <Chip
                                                    label={isFuture(new Date(event.date)) ? 'Upcoming' : 'Past'}
                                                    color={isFuture(new Date(event.date)) ? 'secondary' : 'default'}
                                                    size="small"
                                                    sx={{ borderRadius: '4px' }}
                                                />
                                            </Box>

                                            <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                                                    <CalendarTodayIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                                    {format(new Date(event.date), 'MMMM d, yyyy')}
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                                                    <LocationOnIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                                    {event.location}
                                                </Box>
                                            </Box>

                                            <Typography
                                                variant="body1"
                                                paragraph
                                                sx={{
                                                    mb: 3,
                                                    color: 'text.secondary',
                                                    lineHeight: 1.6
                                                }}
                                            >
                                                {event.description}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<PhotoLibraryIcon />}
                                                sx={{
                                                    borderRadius: '25px',
                                                    px: 3,
                                                    background: 'linear-gradient(45deg, #001F3F, #0066cc)',
                                                    boxShadow: '0 4px 15px rgba(0, 31, 63, 0.2)',
                                                    '&:hover': {
                                                        background: 'linear-gradient(45deg, #0066cc, #001F3F)',
                                                    },
                                                }}
                                                onClick={() => navigate(`/gallery/${encodeURIComponent(event.title || '')}`)}
                                            >
                                                Gallery
                                            </Button>

                                        </Box>
                                    </CardContent>
                                </Box>
                            </Card>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
}

const cardVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.5,
            ease: 'easeOut',
        },
    },
};

export default List;
